const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/user-management/account/$uid.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/user-management/account/$uid.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createCapabilityChecker } from '@/features/authentication/lib/authorizationCapabilities';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { availableOperationsQuery } from '@/features/authentication/services/permissionQueries';
import { UserAuthorizationWorkspacePendingState } from '@/features/user-management/components/UserAuthorizationWorkspacePendingState';
import { userManagementAccessQuery, userManagementPermissionSetsQuery, userManagementUserQuery } from '@/features/user-management/services/userManagementQueries';
import { createFileRoute, notFound } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_workspace/user-management/account/$uid')({
  beforeLoad: requireCapabilities(has => has('users.list')),
  loader: async ({
    context,
    params
  }) => {
    const user = await context.queryClient.ensureQueryData(userManagementUserQuery(params.uid));
    if (!user) throw notFound();
    const availableOperations = await context.queryClient.ensureQueryData(availableOperationsQuery(context.authUid));
    const hasCapability = createCapabilityChecker(availableOperations);
    const principalId = user.authorization.principalId ?? `fb:${user.uid}`;
    const principalExists = user.authorization.principalId != null;
    await Promise.all([hasCapability('authz.permission-sets.list') ? context.queryClient.ensureQueryData(userManagementPermissionSetsQuery) : undefined, hasCapability('authz.assignments.list-global') && principalExists ? context.queryClient.fetchQuery(userManagementAccessQuery(principalId)) : undefined]);
    return {
      user
    };
  },
  pendingComponent: UserAuthorizationWorkspacePendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});